import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { AutoCompleteType } from '../../../subcomponents/form/auto-complete-type';
import { CaptchaField } from '../../../subcomponents/form/field/captcha/captcha-field';
import { InputField } from '../../../subcomponents/form/field/input/input-field';
import { getFieldClassName, getFieldId } from '../../../subcomponents/form/field/utils/field-attribute-utils';
import { getFormattedLengthErrorMessage } from '../../../subcomponents/form/form-field-utils';
import { getHelpTextId } from '../../../subcomponents/form/help-text/utils/get-help-text-id';
import { FieldValidationError } from '../../../types/form/field-validation-error';
import { InvalidFieldNameError } from '../../../types/invalid-field-name-error';
import { convertToPascalCase } from '../../../utils/string-utils';
const b = bemClassBuilder('v-gift-card-checker-field');
export const GiftCardCheckerField = observer(props => {
    const { fieldName, validator, config, displayText, onChange, setHelpText, value, captchaRef } = props;
    const fieldId = getFieldId(b, fieldName);
    const handleSetHelpText = (errorMessage) => setHelpText({ id: getHelpTextId(fieldId), text: errorMessage });
    const commonFieldProps = Object.assign(Object.assign({}, props), { id: fieldId, name: fieldName, className: getFieldClassName(b, fieldName), value: value, showLabel: config.showFieldLabels, validate: (newValue) => validator.validateField(fieldName, newValue), autoCompleteType: AutoCompleteType.Off, onChangeValue: newValue => onChange(fieldName, newValue), setHelpText: errorMessage => handleSetHelpText(errorMessage) });
    switch (props.fieldName) {
        case 'cardNumber':
            return (_jsx(InputField, Object.assign({}, commonFieldProps, { name: "giftCardNumberSearch" // Include 'search' in the name to prevent Safari autofilling with a credit card if the placeholder has 'card number': https://bytes.grubhub.com/b83137b5b1c7
                , type: "number", displayText: {
                    label: displayText.fieldCardNumberInputLabel,
                    placeholder: displayText.fieldCardNumberPlaceholder,
                    requiredMessage: displayText.errorCardNumberRequiredMessage
                } })));
        case 'pin':
            return (_jsx(InputField, Object.assign({}, commonFieldProps, { type: "number", displayText: {
                    label: displayText.fieldPinInputLabel,
                    placeholder: displayText.fieldPinPlaceholder,
                    requiredMessage: displayText.errorPinRequiredMessage,
                    formatMessage: displayText.errorPinFormatMessage,
                    lengthMessage: displayText.errorPinLengthMessage
                } })));
        case 'captcha':
            return (_jsx(CaptchaField, Object.assign({}, commonFieldProps, { captchaRef: captchaRef, setHelpText: undefined, validationConfig: config.validation.captcha, displayText: { requiredMessage: displayText.errorCaptchaRequiredMessage } })));
        default:
            throw new InvalidFieldNameError('GiftCardCheckerField', props.fieldName);
    }
});
GiftCardCheckerField.displayName = 'GiftCardCheckerField';
export const getFormFieldErrorMessage = (fieldName, error, displayText, i18n, config) => {
    const fieldNameInPascalCase = convertToPascalCase(fieldName);
    const errorDisplayText = displayText[`error${fieldNameInPascalCase}${error}Message`] || error;
    if (error === FieldValidationError.Length) {
        return getFormattedLengthErrorMessage(config, errorDisplayText, i18n);
    }
    return errorDisplayText;
};
